import { useState, useEffect } from "react";
import {
  fbGetGroupRegistrationCode,
  fbChangeGroupRegistrationCode,
} from "../../../services/firebaseService/endPoints/admin/groupConfig";
import useAdminDataStore, { selectCurrentGroupId, selectAllGroups } from "../../../store/adminData/adminData";
import LoadingModal from "../../commons/LoadingModal";
import ChantPopConfirm from "../../../CommonComponents/ChantTooltip/ChantPopConfirm";
import { ChantInput } from "../../../CommonComponents";
import ChantButton from "../../../CommonComponents/ChantButton/ChantButton";

const RegistrationCode = () => {
  const currentGroup = useAdminDataStore(selectCurrentGroupId);
  const allGroups = useAdminDataStore(selectAllGroups);
  const groupName = allGroups[currentGroup]?.data?.groupName;

  const [registrationCode, setRegistrationCode] = useState("");
  const [isLoading, setIsLoading] = useState(true);

  const getRegistrationCode = () => {
    fbGetGroupRegistrationCode(currentGroup).then((code) => {
      setRegistrationCode(code);
      setIsLoading(false);
    });
  };

  const handleChangeRegistrationCode = async () => {
    const res = await fbChangeGroupRegistrationCode(currentGroup);
    if (res.success) {
      setRegistrationCode(res.data.code);
    }
  };

  useEffect(() => {
    setIsLoading(true);
    getRegistrationCode();
  }, [currentGroup]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div>
      <LoadingModal loading={isLoading} />
      <form
        onSubmit={(e) => e.preventDefault()}
        className="border rounded mt-4 p-2 px-md-5 py-md-4 mx-md-auto mx-2"
        style={{ maxWidth: "700px" }}
      >
        <ChantInput
          name="registrationCode"
          value={registrationCode}
          label={`Registration code for ${groupName}`}
          disabled
        />
        <div className="d-flex justify-content-center" style={{ marginTop: "8px" }}>
          <ChantPopConfirm
            title="Changing this code will make the previous registration code invalid. Are you sure?"
            onConfirm={handleChangeRegistrationCode}
            onCancel={() => {}}
            okText="Yes"
            cancelText="No"
          >
            <ChantButton style={{ backgroundColor: "#ff4d4f", borderColor: "#ff4d4f" }}>
              Generate a new code
            </ChantButton>
          </ChantPopConfirm>
        </div>
      </form>
    </div>
  );
};

export default RegistrationCode;
